module.exports = __webpack_public_path__ + "static/media/lookup-icon.f31e311a.svg";